import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SurveyCreatorComponent } from './survey-creator.component';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ SurveyCreatorComponent ],
    exports: [ SurveyCreatorComponent ]
})

export class SurveyCreatorModule {}
